import { SplashScreen } from 'components/common/SplashScreen/SplashScreen';
import { type PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch } from 'store';
import { loadMetadata } from 'store/metadata/metadata.actions';
import { isMetadataLoadedSelector } from 'store/metadata/metadata.selectors';
import { AppWrapperContainer } from './styles';

interface AppWrapperProps {
  isAuthInitialized: boolean;
}

export const AppWrapper = ({ children, isAuthInitialized }: PropsWithChildren<AppWrapperProps>) => {
  const dispatch = useDispatch<AppDispatch>();

  const isMetadataLoaded = useSelector(isMetadataLoadedSelector);

  useEffect(() => {
    if (isAuthInitialized) {
      dispatch(loadMetadata());
    }
  }, [dispatch, isAuthInitialized]);

  if (!isAuthInitialized || !isMetadataLoaded) {
    return <SplashScreen text="Customer Experience Center" />;
  }

  return <AppWrapperContainer>{children}</AppWrapperContainer>;
};
